import { useI18n } from 'domains/i18n/hooks'
import { useVisibility } from 'domains/visibility/hooks'
import { className } from 'lib/css'
import { useChatScrollContext } from 'ui/components/conversation/event/chat-scroll/chat-scroll-context'
import Icon from 'ui/components/layout/icon'
import InOutTransition from 'ui/components/widgets/in-out-transition'

const UnreadMessagesButton = () => {
  const { scrollToRef, unreadIds } = useChatScrollContext()
  const { isMinimized } = useVisibility()
  const { t } = useI18n()

  return (
    <InOutTransition isActive={!!unreadIds.length && !isMinimized}>
      <div className={className('unread-messages')}>
        <button
          type="button"
          className={className('button', 'button--primary')}
          onClick={scrollToRef}
        >
          {t('message.unreadMessagesCount', { unreadCount: unreadIds.length })}
          <Icon name="chevronDown" size="32" alt="" />
        </button>
      </div>
    </InOutTransition>
  )
}

export default UnreadMessagesButton
